import React from 'react';
import isNil from 'lodash.isnil';
import { LABEL, PERFORMANCE_LEVEL } from '../../../../constants/shared/TrcConstants';
import { NA } from '../../../../constants/shared/CommonConstants';
import { getPerformanceLevelAbbr } from '../../../../utils/shared/trcUtils';

const { PROFICIENT, NOT_PROFICIENT } = PERFORMANCE_LEVEL;
const { BOOK_PERFORMANCE, READING_ACCURACY, READING_COMP, WRITTEN_COMP } = LABEL;

export const getLevelLabel = isProficient => (
    <span className={`performance-level ${!isProficient ? 'icon-red' : ''}`}>
        {getPerformanceLevelAbbr(isProficient ? PROFICIENT : NOT_PROFICIENT)}
    </span>
);

export const getTrcReadingCompScoreWithLevel = readingComp =>
    readingComp && !isNil(readingComp.actualResult) ? (
        <>
            {`${readingComp.actualResult}/${readingComp.maxResult}`}
            {getLevelLabel(readingComp.proficient)}
        </>
    ) : (
        NA
    );

export const getWrittenCompLabel = writtenComp =>
    writtenComp && !isNil(writtenComp.score) ? (
        <>
            {`${writtenComp.score}/${writtenComp.maxScore}`}
            {getLevelLabel(writtenComp.proficient)}
        </>
    ) : (
        NA
    );

export const getWrittenComp = book => (
    <div className="book-cell book-written-comp display-book-content">
        {getWrittenCompLabel(book.writtenComp)}
    </div>
);

export const getReadingAcc = accuracy => (isNil(accuracy) ? NA : `${accuracy}%`);

export const getTrcCardStats = (performanceLevel, accuracy, readingComp, writtenComp) => ({
    [BOOK_PERFORMANCE]: performanceLevel || NA,
    [READING_ACCURACY]: getReadingAcc(accuracy),
    [READING_COMP]: getTrcReadingCompScoreWithLevel(readingComp),
    [WRITTEN_COMP]: getWrittenCompLabel(writtenComp),
});
